"use client";

import { useState, useEffect } from "react";
import { FaHeartbeat } from "react-icons/fa"; 
import styles from "../css/conditions.module.css";
import { useConsultation } from "../../../../context/ConsultationContext";

export default function Conditions({ patientData = {} }) {
  const [conditions, setConditions] = useState([""]); 
  const { getStepDraft, setStepDraft } = useConsultation();

  useEffect(() => {
    const draft = getStepDraft("patientOverview", null);
    const draftConditions = draft?.conditions;
    
    if (draftConditions && Array.isArray(draftConditions) && draftConditions.length > 0) {
      const cleaned = draftConditions.map((c) => (c ?? "").toString()).filter((s) => s.trim());
      setConditions(cleaned.length ? cleaned : [""]);
    } else {
      const raw = patientData.chronicconditions;
      if (raw == null) {
        setConditions([""]);
        return;
      }
      if (Array.isArray(raw)) {
        const cleaned = raw.map((c) => (c ?? "").toString()).filter((s) => s.trim());
        setConditions(cleaned.length ? cleaned : [""]);
        return;
      }
      const asString = String(raw);
      const parts = asString
        .split(/\r?\n|,/)
        .map((s) => s.trim())
        .filter(Boolean);
      setConditions(parts.length ? parts : [""]);
    }
  }, [patientData.chronicconditions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const conditionNames = conditions.filter(Boolean);
    setStepDraft("patientOverview", (prev) => ({
      ...(prev || {}),
      conditions: conditionNames,
    }));
  }, [conditions]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTextChange = (index, value) => {
    const updated = [...conditions];
    updated[index] = value;
    setConditions(updated);
  };

  const addTextbox = () => {
    setConditions([...conditions, ""]);
  };

  const deleteTextbox = (index) => {
    if (conditions.length === 1) {
      setConditions([""]);
      return;
    }
    const updated = conditions.filter((_, i) => i !== index);
    setConditions(updated);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaHeartbeat className={styles.heartIcon} />
        <h3 className={styles.title}>Chronic Conditions</h3>
      </div>

      <div className={styles.list}>
        {conditions.map((condition, index) => (
          <div key={index} className={styles.row}>
            <input
              type="text"
              className={styles.inputField}
              value={condition}
              onChange={(e) => handleTextChange(index, e.target.value)}
              placeholder="Enter condition..."
            />
            <button 
              className={styles.deleteBtn} 
              onClick={() => deleteTextbox(index)}
              aria-label="Delete"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        ))}
      </div>

      <button className={styles.addBtn} onClick={addTextbox}>
        <span>+</span>
      </button>
    </div>
  );
}